// extracted by mini-css-extract-plugin
module.exports = {"geniusBadge":"FlightCardBadge-module__geniusBadge___0bTmq"};